import { RootState } from '@/store';
import { Module } from 'vuex';

export interface TimerState {
  ongoing: boolean;
}

const state: TimerState = {
  ongoing: false
};

const options: Module<TimerState, RootState> = {
  namespaced: true,
  state: () => state,
  actions: {
    setOngoing: ({ commit }, flip: boolean): void => {
      commit('ongoing', flip);
    }
  },
  mutations: {
    ongoing: (state, flip: boolean) => (state.ongoing = flip)
  }
};

export default options;
